export const STORE_MODULE_EMAIL = 'STORE_MODULE_EMAIL';
